import convertEwsIdToOdataId from '../utils/convertEwsIdToOdataId';
import GriffinServiceResponse from '../store/schema/GriffinServiceResponse';
import { format } from 'owa-strings';
import { getGuid } from 'owa-guid';
import {
    GRIFFIN_REQUEST_ID_URL_FORMAT,
    GRIFFIN_REQUEST_BASEURL,
} from '../helpers/GriffinConstants';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makePostRequest } from 'owa-ows-gateway';
import { trace } from 'owa-trace';
import ResponseClass from 'owa-service/lib/contract/ResponseClass';
import { HttpStatusCode } from 'owa-http-status-codes';
/**
 *
 * This function makes the GWS service call by forming the complete request URL from relative url.
 * @param itemId Specifies the itemId of the mail.
 * @param relativeUrl Specifies the relative url apart from the base url.
 *
 */
export default function makeGriffinServiceRequest(
    itemId: string,
    urlPrefix: string,
    relativePath: string,
    requestObject?: any,
    onServiceRequestError?: (statusCode: number, error?: string) => void
): Promise<GriffinServiceResponse> {
    const oDataId = convertEwsIdToOdataId(itemId);
    const correlationId = getGuid();
    const requestUrl = format(
        GRIFFIN_REQUEST_BASEURL,
        format(GRIFFIN_REQUEST_ID_URL_FORMAT, urlPrefix, oDataId, relativePath)
    );
    let responseClass: ResponseClass;

    return makePostRequest(
        requestUrl,
        requestObject || null,
        correlationId,
        true /*returnFullResponse*/,
        null /*customHeaders*/,
        null /*throwServiceError*/,
        true /*sendPayloadAsBody*/
    )
        .then(response => {
            if (isSuccessStatusCode(response.status)) {
                responseClass = 'Success';
            } else {
                responseClass = 'Error';
                if (onServiceRequestError) {
                    response.length === 0
                        ? onServiceRequestError(HttpStatusCode.ServiceUnavailable)
                        : onServiceRequestError(response.status, response.statusText);
                }
            }
            return {
                Body: {
                    ResponseClass: responseClass,
                },
            };
        })
        .catch(error => {
            trace.error(
                `[TXP] Error when calling Griffin GWS API: ${relativePath}, error: ${error}`
            );
            onServiceRequestError &&
                onServiceRequestError(HttpStatusCode.InternalServerError, error);
            return null;
        });
}
